<div class="sidebar">
	<app-sidebar-header 
		[title]="'bookingDetails.label.contactsLabel' | ibeadmin:'sync'" 
		[confirmation]="INDRA_showSaveSidebarHeader()">
		<div actions *ngIf="INDRA_showSaveSidebarHeader()">
			<button class="button button--small" (click)="INDRA_saveSidebar()">
				{{ 'bookingDetails.text.save' | ibeadmin:'sync' }}
			</button>
		</div>
	</app-sidebar-header>
	<app-loading *ngIf="isServiceLoading"></app-loading>
	
	<ng-container *ngIf="!isServiceLoading && notif.show">
		<app-notification 
			[classes]="'top-gap'" 
			[style]="notif.style" 
			[title]="notif.title">
			<div message>
				{{ notif.message | ibeadmin:'sync' }}
			</div>
			<div actions>
				<button *ngIf="notif.showCloseBtn" class="button" (click)="INDRA_hideNotifications()">
					{{ 'bookingDetails.button.close' | ibeadmin:'sync' }}
				</button>
			</div>
		</app-notification>
	</ng-container>

	<div *ngIf="!isServiceLoading" class="sidebar__body sl--scrollable" #sidebar__body>
		<div class="card-wrapper" *ngIf="!formBookingContacts.hasData && userInfo">
			<div *ngIf="!isCorporate">
				<h4>
					{{'bookingDetails.text.hello' | ibeadmin:'sync'}}, {{ INDRA_printName(userInfo) }}
				</h4>
				<span>
					{{'bookingDetails.text.fillByAccountDetails' | ibeadmin:'sync'}}
				</span>
				<button 
					class="button top-gap full-width-mobile display--block" 
					(click)="INDRA_importUserData()">
					{{'bookingDetails.button.fillPaxDetails' | ibeadmin:'sync'}}
				</button>
			</div>
			<!-- note: from post-sprint 8 client code merge
			<div *ngIf="isCorporate">
				<h4>Hello,</h4>
				<span>Is a company's employee travelling? <br>Choose an employee to import her details.</span>

				<div class="form-field--row grid no-padding">
					<div class="form-field col-12 col-tp-12 col-p-12">
						<label class="label" for="user_employee">Employee</label>
						<app-select-input [id]="'user_employee'" [placeholder]="'Choose company employee'" (change)="TAP_importUserData()"
							[inputOptions]="employees" [(ngModel)]="userEmployee">
						</app-select-input>
					</div>
				</div>
			</div>
			-->
		</div>
		<div class="card-wrapper" *ngIf="hasCookies && !userInfo && dataFromCookie">
			<h4>{{'bookingDetails.text.contactDetailsImported' | ibeadmin:'sync'}}</h4>
			<p>
				{{'bookingDetails.text.resetForm1' | ibeadmin:'sync'}} 
				<a
					[attr.aria-label]="'bookingDetails.aria.resetThisForm' | ibeadmin:'sync'" 
					(click)="INDRA_handleReset()" 
					class="link">
					{{'bookingDetails.text.resetForm2' | ibeadmin:'sync'}} 
				</a> 
				{{'bookingDetails.text.or' | ibeadmin:'sync'}} 
				<a
					[attr.aria-label]="'bookingDetails.aria.deleteAllContactDetails' | ibeadmin:'sync'"
					(click)="INDRA_handleDeleteCookies()"
					class="link">
					{{'bookingDetails.text.deletePaxCookies' | ibeadmin:'sync'}}
				</a>
			</p>
		</div>

		<form class="sidebar__form" [formGroup]="formBookingContacts.group">
			<div>
				<h2 class="title-h2">
					{{ 'bookingDetails.label.email' | ibeadmin:'sync' }}
				</h2>
				<span class="description">
					{{ 'bookingDetails.text.confirmationEmail' | ibeadmin:'sync' }}
				</span>
			</div>

			<div class="form-field--row">
				<div class="form-field no-margin-adjustment">
					<label 
						class="label" 
						for="email">
						{{ 'bookingDetails.label.emailAddressContact' | ibeadmin:'sync' }}
					</label>
					<input 
						placeholder="{{'bookingDetails.label.insertContactEmail' | ibeadmin:'sync'}}" 
						inputmode="email"
						class="input-text"
						formControlName="email"
						name="email"
						id="email"
						type="email"
						[ngClass]="{invalidated: isInvalid('email')}" />
					<span 
						[attr.aria-label]="'bookingDetails.error.emailInvalid' | ibeadmin:'sync'"
						*ngIf="isInvalid('email')"
						aria-live="polite" 
						class="input-error" 
						role="alert">
						{{ 'bookingDetails.error.emailInvalid' | ibeadmin:'sync' }}
					</span>
				</div>
			</div>

			<div class="form-field--row">
				<div class="form-field no-margin-adjustment">
					<label 
						class="label" 
						for="verify-email-adress">
						{{ 'bookingDetails.label.verifyEmailAddressContact' | ibeadmin:'sync' }}
					</label>
					<input 
						placeholder="{{'bookingDetails.label.insertVerifyContactEmail' | ibeadmin:'sync'}}" 
						inputmode="email"
						class="input-text"
						formControlName="verify_email"
						name="verify_email"
						id="verify-email-adress"
						type="email"
						[ngClass]="{invalidated: isInvalid('verify_email')}" />
					<span 
						[attr.aria-label]="'bookingDetails.error.verifyEmailInvalid' | ibeadmin:'sync'"
						*ngIf="isInvalid('verify_email')"
						aria-live="polite" 
						class="input-error" 
						role="alert">
						{{ 'bookingDetails.error.verifyEmailInvalid' | ibeadmin:'sync' }}
					</span>
				</div>
			</div>

			<div class="form-field--row grid top-gap dataprivacy-fields__box">
				<div class="form-field col-12">
					<label class="checkbox-wrapper" for="show-corporate-fields">
						<input
							formControlName="selectGDPR"
							type="checkbox" 
							class="checkbox"
							id="show-corporate-fields">
						<span
						>{{ 'bookingDetails.text.receiveInformation' | ibeadmin:'sync'}}</span>
					</label>
				</div>
				<div class="form-field col-12 col-tp-12 col-p-12 data-privacy">
					<span
					>{{ 'bookingDetails.text.moreInformation' | ibeadmin:'sync'}}
						<a target="blank_" class="link link--external" (click)="INDRA_DataPrivacyExternalUrl()"
							aria-label="Open new window with more info about privacy policy"
							>{{ 'bookingDetails.text.privacyPolicy' | ibeadmin:'sync'}}.
						</a>
					</span>
				</div>
			</div>

			<div class="top-gap">
				<h2 class="title-h2">
					{{ 'bookingDetails.label.phoneNumber' | ibeadmin:'sync' }}
				</h2>
				<span class="description">
					{{ 'bookingDetails.text.contactPhone' | ibeadmin:'sync' }}
				</span>
			</div>

			<div class="form-field--row grid no-padding">
				<div class="form-field col-3 col-tp-3 col-p-12">
					<label class="label" for="phone_type">{{'bookingDetails.label.phoneTypeLabel' | ibeadmin:'sync'}}</label>
					<app-select-input-indra
						selectId="selectPhoneType"
						placeholder="{{'bookingDetails.label.selectPhoneType' | ibeadmin:'sync'}}"
						formControlName="phone_type"
						[options]="contactTypes"
						selectLabel="{{'bookingDetails.alt.selectPhoneType' | ibeadmin: 'sync'}}">
					</app-select-input-indra>
					<span 
						aria-live="polite"
						[attr.aria-label]="INDRA_formErrors('phone_type')  | ibeadmin:'sync'"						
						class="input-error" 
						role="alert" 
						*ngIf="INDRA_formInvalid('phone_type')">
						{{ INDRA_formErrors('phone_type')  | ibeadmin:'sync' }}
					</span>
				</div>

				<div class="form-field col-4 col-tp-4 col-p-12">
					<label class="label" for="phone_prefix">{{'bookingDetails.label.countryCode' | ibeadmin:'sync'}}</label>
					<app-select-input-indra
						selectId="selectPhoneCountry"
						placeholder="{{'bookingDetails.label.selectPhoneCountry' | ibeadmin:'sync'}}"
						formControlName="phone_prefix"
						[optionsTranslated]="true"
						[options]="countryCodeOptions"
						selectLabel="{{'bookingDetails.label.selectPhoneCountry' | ibeadmin:'sync'}}">
					</app-select-input-indra>
					<span 
						aria-live="polite"
						[attr.aria-label]="INDRA_formErrors('phone_prefix')  | ibeadmin:'sync'"
						class="input-error" 
						role="alert" 
						*ngIf="INDRA_formInvalid('phone_prefix')">
						{{ INDRA_formErrors('phone_prefix')  | ibeadmin:'sync' }}
					</span>
				</div>
				<div class="form-field col-5 col-tp-5 col-p-12">
					<label class="label" for="phone-number">
						{{ 'bookingDetails.label.phoneNumber' | ibeadmin:'sync' }}
					</label>
					<input 
						inputmode="tel" 
						class="input-text" 
						formControlName="phone_number" 
						name="phone_number" 
						id="phone-number" 
						[ngClass]="INDRA_hasErrors('phone_number')" 
						maxlength="20"/>
					<span 
						aria-live="polite" 
						[attr.aria-label]="INDRA_formErrors('phone_number')  | ibeadmin:'sync'"
						class="input-error" 
						role="alert" 
						*ngIf="INDRA_formInvalid('phone_number')">
						{{ INDRA_formErrors('phone_number')  | ibeadmin:'sync'}}
					</span>
				</div>
			</div>
		</form>

		<form class="sidebar__form" [formGroup]="formBookingContactsSecondary.group">
			<!-- Secondary Phones -->
			<div formArrayName="items" *ngFor="
					let secondary_phone of INDRA_getSecondaryPhones();
					let index = index
				">
				<div [formGroupName]="index" class="form-field--row grid no-padding">
					<div class="form-field col-3 col-tp-3 col-p-12">
						<label class="label" for="phone_type-{{index}}">{{'bookingDetails.label.phoneTypeLabel' | ibeadmin:'sync'}}</label>
						<app-select-input-indra
							selectId="{{'selectBookingPhoneType'+index}}"
							placeholder="{{'bookingDetails.label.selectPhoneType' | ibeadmin:'sync'}}"
							formControlName="type"
							[options]="contactTypes"
							selectLabel="{{'bookingDetails.alt.selectPhoneType' | ibeadmin: 'sync'}}">
						</app-select-input-indra>
						<span 
							aria-live="polite" 
							[attr.aria-label]="INDRA_formErrorsSecondaryPhones('type', index) | ibeadmin:'sync'"
							class="input-error" 
							role="alert" 
							*ngIf="INDRA_formInvalidSecondaryPhones('type', index)">
							{{ INDRA_formErrorsSecondaryPhones('type', index) | ibeadmin:'sync' }}
						</span>
					</div>

					<div class="form-field col-4 col-tp-4 col-p-12">
						<label class="label" for="phone_prefix-{{index}}">{{'bookingDetails.label.countryCode' | ibeadmin:'sync'}}</label>
						<app-select-input-indra
							selectId="{{'selectBookingPhoneCountry'+index}}"
							placeholder="{{'bookingDetails.label.selectPhoneCountry' | ibeadmin:'sync'}}"
							formControlName="prefix"
							[optionsTranslated]="true"
							[options]="countryCodeOptions"
							selectLabel="{{'bookingDetails.alt.selectPhoneCountry' | ibeadmin: 'sync'}}">
						</app-select-input-indra>
						<span 
							aria-live="polite" 
							[attr.aria-label]="INDRA_formErrorsSecondaryPhones('prefix', index) | ibeadmin:'sync'"
							class="input-error" 
							role="alert" 
							*ngIf="INDRA_formInvalidSecondaryPhones('prefix', index)">
							{{ INDRA_formErrorsSecondaryPhones('prefix', index) | ibeadmin:'sync' }}
						</span>
					</div>
					<div class="form-field col-4 col-tp-4 col-p-11">
						<label class="label" for="phone-number-{{index}}">
							{{ 'bookingDetails.label.phoneNumber' | ibeadmin:'sync' }}
						</label>
						<input 
							inputmode="tel" 
							class="input-text" 
							formControlName="number" 
							id="phone-number-{{index}}" 
							[ngClass]="INDRA_hasErrorsSecondaryPhones('number', index)" />
						<span 
							aria-live="polite" 
							[attr.aria-label]="INDRA_formErrorsSecondaryPhones('number', index) | ibeadmin:'sync'"
							class="input-error" 
							role="alert" 
							*ngIf="INDRA_formInvalidSecondaryPhones('number', index)">
							{{ INDRA_formErrorsSecondaryPhones('number', index) | ibeadmin:'sync' }}
						</span>
					</div>
					<div class="form-field col-1 col-tp-1 col-p-1">
						<app-svg 
							class="remove-contact" 
							(click)="INDRA_removeContact(index)" 
							svg="icons.svg#general--close" 
							[attr.aria-label]="'Remove contact'" 
							[alt]="'Remove icon'">
						</app-svg>
					</div>
				</div>
			</div>

			<button class="button button-main-line top-gap" (click)="INDRA_addNewContact()" *ngIf="INDRA_showAddNewButton()">
				{{ 'bookingDetails.label.addPhoneNumber' | ibeadmin:'sync' }}
			</button>
		</form>

		<div *ngIf="INDRA_showClearButton()" class="form-link--wrapper">
			<a class="link" (click)="INDRA_clearForm()" href="javascript:;" role="button">
				{{ 'bookingDetails.text.clearDetails' | ibeadmin:'sync' }}
			</a>
		</div>

		<div *ngIf="INDRA_showCancelButton()" class="form-link--wrapper">
			<a class="link"
				 href="javascript:;"
				 role="button"
				(click)="INDRA_cancelEditFormContacts()">
				{{ 'bookingDetails.text.cancelEditing' | ibeadmin:'sync' }}
			</a>
		</div>
		<!-- </ng-container> -->

		<button class="button full-width top-gap sm-mb-10" (click)="INDRA_saveSidebar()" *ngIf="INDRA_showSaveSidebarHeader()" [disabled]="triggerCreatePassenger || triggerCreateContact">
			{{ 'bookingDetails.text.updateContacts' | ibeadmin:'sync' }}
		</button>
	</div>
</div>
